import React from "react";

function CardViewTour() {
  return (
    <div>
      <p>
        Toggle between card view and table view to see your apps the way you
        prefer.
      </p>
    </div>
  );
}

export default CardViewTour;
